import { render, staticRenderFns } from "./alertMissionPersonnelDirector.vue?vue&type=template&id=672b7701&scoped=true&"
import script from "./alertMissionPersonnelDirector.vue?vue&type=script&lang=js&"
export * from "./alertMissionPersonnelDirector.vue?vue&type=script&lang=js&"
import style0 from "./alertMissionPersonnelDirector.vue?vue&type=style&index=0&id=672b7701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b7701",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VContainer,VHover,VIcon,VRow})
